import React, { useState } from 'react';
import App from '@app';
import { Body, PageHeader, FormCadastro, Field, Select, SubmitButton } from '@components';
import { getClientes } from '@sdk/Clientes';
import styled from 'styled-components';
import TableVariaveisAmbiente from './TableVariaveisAmbiente';

const FormCadastroStyled = styled(FormCadastro)`
  width: 100%;
  margin-bottom: 15px;
`;

const FieldCliente = styled(Field)`
  width: 100%;
  padding-right: 15px;
`;

export default function VariaveisAmbiente() {
  const [form] = FormCadastroStyled.useForm();
  const [idCliente, setIdCliente] = useState(-1);

  const handleSubmit = (data) => {
    const { idCliente } = data;
    setIdCliente(-1);
    setIdCliente(idCliente);
  };

  return (
    <App>
      <Body>
        <PageHeader title="Variáveis de Ambiente">
          <FormCadastroStyled form={form} hideRequiredMark onFinish={handleSubmit}>
            <FieldCliente label="Cliente" name="idCliente" rules={[{ required: true, message: 'Informe o cliente' }]}>
              <Select
                form={form}
                id="idCliente"
                name="idCliente"
                action={() => getClientes()}
                placeholder="Selecione um cliente"
                autoFocus
              />
            </FieldCliente>
            <SubmitButton type="success" htmlType="submit" block>
              Buscar
            </SubmitButton>
          </FormCadastroStyled>

          {idCliente === -1 ? <></> : <TableVariaveisAmbiente idCliente={idCliente} />}
        </PageHeader>
      </Body>
    </App>
  );
}
